import TrainingExtraView from './TrainingExtraView';

export default TrainingExtraView;
